import { render, staticRenderFns } from "./TemasComponent.vue?vue&type=template&id=46aa1fec&scoped=true"
import script from "./TemasComponent.vue?vue&type=script&lang=js"
export * from "./TemasComponent.vue?vue&type=script&lang=js"
import style0 from "./TemasComponent.vue?vue&type=style&index=0&id=46aa1fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aa1fec",
  null
  
)

export default component.exports